import { apiClient as api } from './httpClient';

/** Recebimentos (RN-544): o que entrou pelo caixa do paciente, por dia e forma de pagamento */
export interface ReceiptsReportRow {
  paymentId: string;
  /** data/hora no fuso da entidade (ISO sem offset) */
  date: string;
  patientId: string;
  patientName: string;
  sessions: number;
  method1Id: string | null;
  method1Name: string | null;
  value1: number | null;
  method2Id: string | null;
  method2Name: string | null;
  value2: number | null;
  total: number;
  reverted: boolean;
  byInjunction: boolean;
  invoiceUrl: string | null;
  notes: string | null;
  /** conferência (RN-544b): o flag conciliation_* da tabela */
  conciliationChecked: boolean;
  conciliationCheckedAt: string | null;
  conciliationCheckedBy: string | null;
}

export interface ReceiptsByMethod { method: string; total: number; count: number; }
export interface ReceiptsByDay { day: string; total: number; count: number; }
export interface ReceiptsOption { id: string; name: string; }

export interface ReceiptsReport {
  from: string;
  to: string;
  total: number;
  count: number;
  average: number;
  revertedTotal: number;
  revertedCount: number;
  toCheckTotal: number;
  toCheckCount: number;
  byMethod: ReceiptsByMethod[];
  byDay: ReceiptsByDay[];
  items: ReceiptsReportRow[];
  methods: ReceiptsOption[];
  professionals: ReceiptsOption[];
}

export type ReceiptsSituation = 'unchecked' | 'checked' | 'active' | 'reverted' | 'all';

export interface ReceiptsReportFilters {
  from?: string;
  to?: string;
  methodId?: string;
  professionalId?: string;
  situation?: ReceiptsSituation;
}

const query = (filters: ReceiptsReportFilters): string => {
  const q = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) q.set(k, v); });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const receiptsReportService = {
  get: async (filters: ReceiptsReportFilters): Promise<ReceiptsReport> => {
    const response = await api.get(`/receipts-report${query(filters)}`, { timeout: 60000 });
    return response.data;
  },

  /** Inclui o link da NF num pagamento sem link (só inclusão; alterar é no caixa do paciente) */
  setInvoice: async (paymentId: string, invoiceUrl: string): Promise<void> => {
    await api.put(`/receipts-report/payments/${paymentId}/invoice`, { invoiceUrl }, { timeout: 60000 });
  },

  /** Conferência do recebimento (RN-544b); desmarcar é só do Administrador */
  setConciliation: async (paymentId: string, checked: boolean): Promise<void> => {
    await api.put(`/receipts-report/payments/${paymentId}/conciliation`, { checked }, { timeout: 60000 });
  },

  exportXlsx: async (filters: ReceiptsReportFilters): Promise<Blob> => {
    const response = await api.get(`/receipts-report/xlsx${query(filters)}`, { responseType: 'blob', timeout: 60000 });
    return response.data;
  },
};
